// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3kGo0","list":"BalanceDue_list__3MVnR","listRow":"BalanceDue_listRow__1nXyr","total":"BalanceDue_total__k4rvr"};